export default __webpack_public_path__ + "fonts/nexa-light.otf";